@import "@docfy/ember/code-block.css";
@import "./components/index.css";
@import "./layout.css";
@import "./utils.css";

:root {
  /* colors */
  --ember-brand: #e04e39;
  --ember-black: #212121;
  --ember-burnt-ember: #9b2918;
  --ember-gray: #817f7f;
  --ember-blue: #1e719b;
  --ember-faint-gray: #efebea;
  --ember-light-blue: #74b0ce;
  --ember-linen: #fdf7f6;
  --ember-yellow: #fbc840;
  --ember-white: #fdfdfd;

  /* breakpoints
   * NOTE: @media does not support var()
   * */
  very-small: 30rem;
  small: 60rem;
}

html {
  font-size: 16px;
  height: 100%;
}

body {
  background-color: rgb(244, 246, 248);
  color: rgb(66, 71, 79);
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell,
    "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 1.5rem 2rem 3rem 2rem;
}

* {
  margin: 0;
  padding: 0;
}

.grid {
  display: grid;
  gap: 0.5rem;
}

.body-wrapper {
  max-width: 70rem;
  margin: 0 auto;
  position: relative;
}

h1 {
  font-size: 1.75rem;
  font-weight: 400;
}

h2 {
  font-size: 1.25rem;
  font-weight: 500;
}

h3 {
  font-size: 1.2rem;
  font-weight: 500;
}

h4 {
  font-size: 1rem;
  font-weight: 600;
}

a {
  color: rgb(207, 45, 32);
}

p {
  line-height: 1.5rem;
  margin-bottom: 1rem;
}

code {
  font-family: ui-monospace, monospace;
}

p > code {
  background: var(--ember-faint-gray);
  color: black;
  font-size: 0.875rem;
  line-height: 1rem;
  padding: 0.125rem 0.25rem;
}

nav {
  display: flex;
  gap: 0.5rem;
}

@media screen and (max-width: 30rem) {
  body {
    padding: 0.5rem 0.5rem 2rem 0.5rem;
  }

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 1.1rem;
  }
}
